<div class="asset-item" (click)="downloadFile($event)" title="{{attachment.description}}" [class.notWorksptep]="attachment.workstepId != ticketSrv.activeWorkstepId" [ngStyle]="{'maxWidth.px': maxWidth350 ? 380 : 'auto'}" [class.border]="withBorder">
  <div>
    <div class="attachmentIcon" [innerHTML]="attachment | AttachmentIcon | safeHtml : true"></div>
    <div class="desc">
      <h3>
        @if(attachment.type == "Artikel"){
          @if (attachment.calculated) {
            <h4>Bereits berechnet</h4>
          }
          @if (attachment?.quantity) {
            <span>{{attachment?.quantity}}x</span>
          }
        }
        {{attachment.description}}
      </h3>
      @if (attachment?.date) {
        <h4><span>{{attachment?.date | timeFormat: "DD.MM.YYYY HH:mm" : true}}</span></h4>
      }
      @if(attachment.type == "Artikel" && attachment.serialNumbersRequired){
        <h4> <span
          [ngClass]="{'green-font': serialNumberCount == attachment?.quantity, 'red-font': (serialNumberCount > attachment?.quantity) || serialNumberCount == 0, 'yellow-font': serialNumberCount > 0 && serialNumberCount < attachment?.quantity}"
        >{{serialNumberCount}}/{{attachment.quantity}}</span> Seriennummern erfasst</h4>
      }

    </div>
  </div>
  @if (canDelete) {
    <div>
      <div class="item-icon cloud-icon" [innerHTML]="attachment | AttachmentDownloadedIcon | safeHtml : true " ></div>
      <div class="item-icon" (click)="deleteFile($event)">
        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="xmark" class="svg-inline--fa fa-xmark fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"></path></svg>
      </div>
    </div>
  }
  @if (attachment.type == 'Datei' && !canDelete) {
    <svg class="download-attachments"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M208 281.4c-12.5-12.5-32.76-12.5-45.26-.002l-78.06 78.07l-30.06-30.06c-6.125-6.125-14.31-9.367-22.63-9.367c-4.125 0-8.279 .7891-12.25 2.43c-11.97 4.953-19.75 16.62-19.75 29.56v135.1C.0013 501.3 10.75 512 24 512h136c12.94 0 24.63-7.797 29.56-19.75c4.969-11.97 2.219-25.72-6.938-34.87l-30.06-30.06l78.06-78.07c12.5-12.49 12.5-32.75 .002-45.25L208 281.4zM487.1 0h-136c-12.94 0-24.63 7.797-29.56 19.75c-4.969 11.97-2.219 25.72 6.938 34.87l30.06 30.06l-78.06 78.07c-12.5 12.5-12.5 32.76 0 45.26l22.62 22.62c12.5 12.5 32.76 12.5 45.26 0l78.06-78.07l30.06 30.06c9.156 9.141 22.87 11.84 34.87 6.937C504.2 184.6 512 172.9 512 159.1V23.1C512 10.74 501.3 0 487.1 0z"/></svg>
  }
</div>